import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  children?: ReactNode
}

// rehype-slug adds id attributes; rehype-autolink-headings injects
// the anchor <a> as a child. These styled wrappers just layer
// typography + scroll-margin on top of whatever rehype produces.

export function H1({ className, children, ...props }: HeadingProps) {
  return (
    <h1
      className={cn(
        'scroll-mt-20 text-2xl font-bold tracking-tight text-fg mb-4 mt-2',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}

export function H2({ className, children, ...props }: HeadingProps) {
  return (
    <h2
      className={cn(
        'scroll-mt-20 text-xl font-semibold tracking-tight text-fg mt-8 mb-3 border-b border-border pb-1',
        className,
      )}
      {...props}
    >
      {children}
    </h2>
  )
}

export function H3({ className, children, ...props }: HeadingProps) {
  return (
    <h3
      className={cn(
        'scroll-mt-20 text-base font-semibold text-fg mt-6 mb-2',
        className,
      )}
      {...props}
    >
      {children}
    </h3>
  )
}
